import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Check } from "@phosphor-icons/react";

// Only the color itself is customizable (icon shape stays FolderSimple) -
// a fixed, curated swatch list keeps every folder's accent visually
// consistent with the app's theme instead of letting users pick arbitrary
// hex values that could clash.
export const FOLDER_COLOR_SWATCHES = [
  "#D97706", "#DC2626", "#EA580C", "#65A30D", "#0D9488",
  "#0284C7", "#4F46E5", "#9333EA", "#DB2777", "#475569",
];

export function FolderColorDialog({ folder, onOpenChange, onSave }) {
  const { t } = useTranslation();

  const handlePick = (color) => {
    onSave(folder.id, color);
    onOpenChange(false);
  };

  return (
    <Dialog open={!!folder} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none max-w-xs" data-testid="folder-color-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{t("folderColorDialog.title")}</DialogTitle>
          <DialogDescription>{t("folderColorDialog.description")}</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-5 gap-3 py-1">
          {FOLDER_COLOR_SWATCHES.map((color) => (
            <button
              key={color}
              type="button"
              data-testid={`folder-color-swatch-${color.slice(1)}`}
              onClick={() => handlePick(color)}
              title={color}
              style={{ backgroundColor: color }}
              className="h-9 w-9 flex items-center justify-center transition-transform hover:scale-110"
            >
              {folder?.color === color && <Check size={16} weight="bold" className="text-white" />}
            </button>
          ))}
        </div>
        <button
          type="button"
          data-testid="folder-color-reset-button"
          onClick={() => handlePick(null)}
          className="w-full text-left px-3 py-2 text-sm font-medium border border-border hover:bg-secondary transition-colors flex items-center justify-between"
        >
          {t("folderColorDialog.defaultColor")}
          {!folder?.color && <Check size={14} weight="bold" />}
        </button>
      </DialogContent>
    </Dialog>
  );
}
